import { ArrowRight, Heart, MoonStar, Sparkles } from 'lucide-react'
import { Link } from 'react-router-dom'
import { RoomCard } from '../components/RoomCard'
import { AnnouncementCard } from '../components/AnnouncementCard'
import { SectionHeading } from '../components/SectionHeading'
import { Seo } from '../components/Seo'
import { StatePanel } from '../components/StatePanel'
import { siteConfig } from '../config/site'
import { sanctuaryRooms } from '../data/rooms'
import { announcements } from '../data/announcements'

export function HomePage() {
  return (
    <>
      <Seo />
      <section className="hero hero--brand">
        <img
          className="hero__art hero__art--ambient"
          src={siteConfig.heroArtworkPath}
          alt=""
          aria-hidden="true"
          loading="eager"
          fetchPriority="low"
          decoding="async"
        />
        <div className="hero__shade" aria-hidden="true" />
        <div className="shell hero__content hero__content--brand">
          <div className="hero__copy">
            <p className="eyebrow"><MoonStar size={16} aria-hidden="true" /> Welcome in, night owl</p>
            <h1>The Midnight<br /><em>Sanctuary</em></h1>
            <p className="hero__tagline">{siteConfig.tagline}</p>
            <p className="hero__intro">A warm corner of the internet to relax, talk, game, create, laugh, meet good people and be entirely yourself.</p>
            <div className="hero__actions">
              <Link to="/join" className="button button--gold">Join the Sanctuary <ArrowRight size={18} /></Link>
              <a href="#explore" className="button button--ghost">Explore the Sanctuary</a>
            </div>
          </div>

          <div className="hero__logo-wrap">
            <div className="hero__logo-frame">
              <img
                className="hero__logo"
                src={siteConfig.logoPath}
                alt="The Midnight Sanctuary official logo"
                width="1440"
                height="1428"
                loading="eager"
                fetchPriority="high"
                decoding="async"
              />
            </div>
          </div>
        </div>
        <a className="hero__scroll" href="#explore"><span>Step inside</span><span aria-hidden="true">↓</span></a>
      </section>

      <section id="explore" className="section shell">
        <SectionHeading eyebrow="Rooms to wander" title="There’s a place here for every kind of night." description="Follow the candlelight and find the corner that feels like yours." />
        <div className="room-grid room-grid--preview">
          {sanctuaryRooms.slice(0, 6).map((room) => <RoomCard key={room.name} room={room} compact />)}
        </div>
        <div className="section-action"><Link to="/community" className="text-link">Explore every room <ArrowRight size={17} /></Link></div>
      </section>

      <section className="section section--warm">
        <div className="shell welcome-grid">
          <div className="welcome-orbit" aria-hidden="true"><MoonStar /><span /><span /><span /></div>
          <div>
            <p className="eyebrow"><Sparkles size={16} /> A softer place to land</p>
            <h2>Come as you are.<br />Stay because it feels like home.</h2>
            <p>The Midnight Sanctuary is built around kindness, curiosity and the simple comfort of finding people you can be yourself with. No performance. No pressure. Just genuine company when you need it.</p>
            <div className="welcome-note"><Heart size={20} /><span>Warm welcomes, thoughtful conversation and room to breathe.</span></div>
            <Link to="/sanctuary" className="text-link">Our story and values <ArrowRight size={17} /></Link>
          </div>
        </div>
      </section>

      <section className="section shell home-happenings">
        <div>
          <SectionHeading eyebrow="Tonight & beyond" title="Gather round when the mood takes you." description="Events and spontaneous plans are organised with the community inside Discord." />
          <StatePanel title="See what’s happening in Discord" message="Game nights, creative evenings and community get-togethers will be posted in the server as they are confirmed." />
          <Link to="/join" className="text-link">Join to see what’s happening <ArrowRight size={17} /></Link>
        </div>
        <div>
          <SectionHeading eyebrow="From the noticeboard" title="Sanctuary notes." />
          <div className="announcement-list">{announcements.map((announcement) => <AnnouncementCard key={announcement.id} announcement={announcement} />)}</div>
        </div>
      </section>
    </>
  )
}
